<template>
  <div class="container-fluid">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-md-4 mt-4">
          <div class="form-group">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/inicio">Início</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/evento">Eventos</a>
                </li>
                <li class="breadcrumb-item">
                  <a style="color: grey; hover: none"> Cadastrar Evento </a>
                </li>
              </ol>
              <h3 style="color: #000; margin-left: 15px">Cadastrar Evento</h3>
            </nav>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label>Nome do Evento</label>
          <input
            type="text"
            class="form-control"
            v-model="state.titulo"
            placeholder="Insira o nome do evento"
          />
        </div>
        <div class="col-4">
          <label>Nome URL</label>
          <input
            type="text"
            class="form-control"
            v-model="state.titulo_url"
            placeholder="Insira o nome url"
          />
        </div>
        <div class="col-4">
          <label>Subtítulo</label>
          <input
            type="text"
            class="form-control"
            v-model="state.subtitulo"
            placeholder="Insira um subtítulo"
          />
        </div>
        <div class="col-3">
          <div class="form-group">
            <label>Data</label>
            <input
              type="date"
              class="form-control"
              v-model="state.data_evento"
            />
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label>Status</label>
            <select class="form-select" v-model="state.status">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label>Destaque</label>
            <select class="form-select" v-model="state.destaque1">
              <option value="SIM">Sim</option>
              <option value="NAO">Não</option>
            </select>
          </div>
        </div>
        <div class="col-3">
          <label>Link Externo</label>
          <input
            type="text"
            class="form-control"
            v-model="state.link_externo"
            placeholder="Insira um link"
          />
        </div>
        <div class="col-3">
          <label>Link YouTube</label>
          <input
            type="text"
            class="form-control"
            v-model="state.link_youtube"
            placeholder="Insira um link"
          />
        </div>
        <div class="col-12">
          <label>Texto do Evento</label>
          <textarea
            type="text"
            class="form-control"
            v-model="state.texto"
          ></textarea>
        </div>
        <div class="col-md-6">
          <label>Imagem</label>
          <input type="file" class="form-control" @change="adicionarImagem" />
        </div>
      </div>
      <div
        style="display: flex; margin-top: 20px"
        class="col-md-8 offset-2"
        v-if="state.imagem.imagem"
      >
        <img :src="state.imagem.imagem" class="imagem" />
        <button class="btn_deletar_imagem" @click="removerImagem">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            fill="currentColor"
            class="bi bi-x-lg mb-2"
            viewBox="0 0 16 16"
          >
            <path
              d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
            />
          </svg>
        </button>
      </div>
      <div class="row justify-content-end">
        <div class="col-auto">
          <button
            class="btn btn_voltar btn-secondary me-3"
            id="voltar-button"
            type="submit"
            @click="router.push({ name: 'evento' })"
          >
            Voltar
          </button>

          <button
            class="btn btn_salvar"
            id="submit-button"
            type="submit"
            @click="salvarEvento()"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      titulo_url: "",
      titulo: "",
      data_evento: "",
      status: "ATIVO",
      subtitulo: "",
      texto: "",
      destaque1: "",
      link_externo: "",
      link_youtube: "",
      imagem: {},
      imagens_deletar: [],
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fechtEvento();
      }
    });
    async function fechtEvento() {
      try {
        const { data } = await services.evento.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.titulo = data.titulo;
        state.titulo_url = data.titulo_url;
        state.subtitulo = data.subtitulo;
        state.data_evento = data.data_evento;
        state.texto = data.texto;
        state.status = data.status;
        state.destaque1 = data.destaque1;
        state.link_externo = data.link_externo;
        state.link_youtube = data.link_youtube;
        state.imagem.imagem = data.imagem;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarEvento() {
      let dados = new FormData();
      dados.append("titulo", state.titulo);
      dados.append("titulo_url", state.titulo_url);
      dados.append("data_evento", state.data_evento);
      dados.append("status", state.status);
      dados.append("subtitulo", state.subtitulo);
      dados.append("destaque1", state.destaque1);
      dados.append("texto", state.texto);
      dados.append("link_externo", state.link_externo);
      dados.append("link_youtube", state.link_youtube);
      if (state.imagem.file != null) {
        dados.append("imagem", state.imagem.file);
      }
      if (!state.id) {
        try {
          await services.evento.save(dados, token);
          router.push({ name: "evento" });
        } catch (error) {
          console.log(error);
        }
      } else {
        dados.append("id", state.id);
        dados.append("_method", "PATCH");
        if (state.imagem.imagem == undefined) {
          try {
            await services.evento.deletarImagem({
              id: dados.get("id"),
            });
          } catch (error) {
            console.log(error);
          }
        }
        try {
          await services.evento.update(dados, token);
          router.push({ name: "evento" });
        } catch (error) {
          console.log(error);
        }
      }
    }
    async function adicionarImagem(event) {
      var img = event.target.files[0];

      var objImagem = new Object();
      objImagem.file = img;
      objImagem.imagem = URL.createObjectURL(img);
      state.imagem = objImagem;
      console.log(objImagem);
    }
    async function removerImagem() {
      state.imagem = {};
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      removerImagem,
      adicionarImagem,
      salvarEvento,
      router,
      state,
    };
  },
};
</script> 
  
  <style scoped>
label {
  font-size: 14pt;
  color: #000;
  margin-bottom: 0;
}
input {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
input:focus {
  border: solid 1px blue;
}
select {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
select:focus {
  border: solid 1px blue;
}
textarea {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
textarea:focus {
  border: solid 1px blue;
}
.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}
.btn_salvar:hover {
  color: #fff;
}
.card {
  min-height: 94.8vh;
}
.btn_deletar_imagem {
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: rgb(170, 0, 0);
  color: #fff;
  border: solid 1px rgb(170, 0, 0);
  border-radius: 5px;
  transition: 0.3s;
}
.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}
img {
  width: 100%;
  height: auto;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>